module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Ga-Hc-Ic-Jb.a996b8e1.png";